import roles from "@/roles";
export default [
  {
    icon: "playlist_add",
    title: "Queue",
    roles: [roles.ADMIN, roles.QUEUE_ADMIN],
    children: [
      {
        router: true,
        title: "Queue Management",
        to: "QueueManagement",
        roles: [roles.ADMIN, roles.QUEUE_ADMIN]
      },
      {
        router: true,
        title: "Local Engagement Time",
        to: "LocalEngagementTime",
        roles: [roles.ADMIN, roles.QUEUE_ADMIN]
      }
    ]
  }
];
